// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/components/static/AuditTool/utils.ts"
);
import.meta.hot.lastModified = "1717182690460.9346";
}
// REMIX HMR END

export const intentToObject = {
    "metrics:mobile": {
        device: "mobile",
        type: "speed",
    },
    "metrics:desktop": {
        device: "desktop",
        type: "speed",
    },
    opengraph: {
        type: "opengraph",
    },
} as const;

export const buildSearchParams = ({
    url,
    intent
}: {
    url: string;
    intent: keyof typeof intentToObject;
}) => {
    const intentValues = intentToObject[intent];
    const type = intentValues.type;
    const device =
        intentValues.type === "speed" ? intentValues.device : undefined;

    const params = new URLSearchParams();
    params.set("url", url);
    params.set("reportType", type);
    if (device) {
        params.set("device", device);
    }

    return params;
}

const calculateResultVariant = (result: {
    passing: number,
    total: number,
}): "approval" | "boost" | "urgent" => {
    if (result.passing < Math.floor(result.total / 2)) {
        return "urgent";
    }
    if (result.passing === result.total) {
        return "approval";
    }
    return "boost";
}

export const calculateAttributesPassing = (audit: any) => {
    if (audit?.opengraph) {
        const auditEntries = Object.entries(audit.opengraph) as Array<
            [string, { audit: { pass: boolean } }]
        >;
        const passing = auditEntries.filter(
            ([cardName, card]) => cardName !== "opengraph" && card.audit.pass
        );
        const result = {
            passing: passing.length,
            total: auditEntries.length - 1,
        }

        return {
            result,
            variant: calculateResultVariant(result)
        }
    }
    if (audit?.crux) {
        const result = {
            passing: 3,
            total: 3,
        }
        return {
            result,
            variant: audit.crux.pass ? "approval" : "boost" as "approval" | "boost"
        }
    }
    if (audit?.psi) {
        const categories = audit.psi.categories || audit.psi
        const categoriesEntries = Object.entries(categories) as Array<
            [string, { score: number }]
        >;
        const categoriesWithoutPwa = categoriesEntries.filter(
            ([categoryName]) => categoryName !== "pwa"
        );
        const passing = categoriesWithoutPwa.filter(
            ([_, category]) => {
                const score = typeof category === 'number' ? category : category.score;
                const normalizeScore = score <= 1 ? score * 100 : score;
                return normalizeScore >= 90;
            }
        );
        const result = {
            passing: passing.length,
            total: categoriesWithoutPwa.length,
        }
        return {
            result,
            variant: calculateResultVariant(result)
        }
    }
    return null;
};

export const getDisclaimer = (audit: any) => {
    if (audit.crux) {
        return "*Based on Google's Chrome UX Report over the latest 28-day collection period.";
    }
    if (audit.psi) {
        return "*Based on Google's Lighthouse Performance Audit over the latest 28-day collection period.";
    }

    return "";
};